export default __webpack_public_path__ + "static/media/polangui.491b580b.jpg";